export const filterOperationData = [
  {
    id: 1,
    primaryText: "Duty Type",
    subItems: [
      { value: "Airport", list: "Airport Transfer", key: "Duty Type" },
      { value: "B2bRental", list: "Rental",key: "Duty Type" },
      { value: "OutStationRound",list: "Outstation", key: "Duty Type" },
    ],
  },
];